export default __webpack_public_path__ + "static/media/08.4b3352f4.jpg";